<template>
  <svg
    class="astronaut"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- One path on purpose: nav icons get a translucent colour, and separate paths would darken where they overlap. -->
    <path d="M4 10a8 8 0 0 1 16 0v4a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4zM4 11H3a1 1 0 0 0 0 2h1M20 11h1a1 1 0 0 1 0 2h-1M4 11a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3M6 21a20 20 0 0 0 12 0" />
    <g class="_eyes-open">
      <path d="M9 12v2" />
      <path d="M15 12v2" />
    </g>
    <g class="_eyes-happy">
      <path d="M7.5 14a1.5 1.5 0 0 1 3 0" />
      <path d="M13.5 14a1.5 1.5 0 0 1 3 0" />
    </g>
  </svg>
</template>

<script>
export default { name: 'Astronaut' };
</script>

<style scoped lang="scss" type="text/scss">
  .astronaut {
    transform-origin: 50% 100%;

    ._eyes-open,
    ._eyes-happy {
      transform-box: fill-box;
      transform-origin: 50% 100%;
    }

    ._eyes-open {
      transition: transform .16s ease-out .12s, opacity .1s .12s;
    }

    ._eyes-happy {
      opacity: 0;
      transition: transform .12s ease-in, opacity .08s .04s;
      transform: scaleY(0);
    }
  }

  .icon-hover-host:hover .astronaut {
    animation: hop .56s cubic-bezier(.3, .7, .4, 1);

    ._eyes-open {
      opacity: 0;
      transition: transform .11s ease-in .09s, opacity .06s .14s;
      transform: scaleY(0);
    }

    ._eyes-happy {
      opacity: 1;
      transition: transform .26s cubic-bezier(.34, 1.9, .64, 1) .19s, opacity .06s .19s;
      transform: scaleY(1);
    }
  }

  @keyframes hop {
    0% { transform: translateY(0) scale(1, 1); }
    18% { transform: translateY(0) scale(1.1, .88); }
    45% { transform: translateY(-20%) scale(.94, 1.07); }
    72% { transform: translateY(0) scale(1.07, .92); }
    86% { transform: translateY(0) scale(.98, 1.02); }
    100% { transform: translateY(0) scale(1, 1); }
  }

  @media (prefers-reduced-motion: reduce) {
    .icon-hover-host:hover .astronaut {
      animation: none;
    }
  }
</style>
